// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const useStickyfill = require('client-v2/common/hooks/stickyfill')
// Container imports
const TopCallToActionExplainerApp = require('client-v2/logged-out-landing/containers/top-call-to-action/components/explainer-app-smart')
const TopCallToActionExplainerButtons = require('client-v2/logged-out-landing/containers/top-call-to-action/components/explainer-buttons-smart')

const bem = BemEntity('TopCallToActionExperimentAExplainer')

function TopCallToActionExperimentAExplainer(props) {
  return tag('div', {
    ref: useStickyfill(),
    className: classNames(
      bem.block(),
      props.className
    )
  },
    tag('div', {
      className: bem.element('heading')
    },
      `All your favorite things.\n`,
      `All in one place.`
    ),
    tag('div', {
      className: bem.element('subheading')
    },
      `Curate and share the best of the internet.\n`,
      `Mix learns what you love to show you even more.`
    ),
    tag(TopCallToActionExplainerApp),
    tag(TopCallToActionExplainerButtons)
  )
}

module.exports = TopCallToActionExperimentAExplainer
